<mat-toolbar class="shrink-0 shadow-sm z-10 relative bg-primary-container">
  @if (!hideToggle()) {
    <button matIconButton (click)="onToggleMenu()" aria-label="Toggle sidenav">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <span>HLSS</span>
  <span class="grow"></span>
  <button matButton (click)="onSignOut()">サインアウト</button>
</mat-toolbar>
